import { render, staticRenderFns } from "./DocAcaoPrazoRegularizar.vue?vue&type=template&id=c8b0401e&scoped=true&lang=pug&"
import script from "./DocAcaoPrazoRegularizar.vue?vue&type=script&lang=js&"
export * from "./DocAcaoPrazoRegularizar.vue?vue&type=script&lang=js&"
import style0 from "./DocAcaoPrazoRegularizar.vue?vue&type=style&index=0&id=c8b0401e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b0401e",
  null
  
)

export default component.exports